import { apiNames, apiOperationIds } from 'constants/api/repoApi';
import { getApiId } from 'utils/apiUtils';


export const matchingManagerTableApiId = getApiId(apiNames.MATCHING_MANAGER, apiOperationIds.MATCHING_MANAGER_TABLE);
export const updateWorkflowStatusApiId = getApiId(apiNames.WORKFLOW_STATUS, apiOperationIds.WORKFLOW_STATUS_UPDATE);
